import UserReport from "./UserReport.component.jsx";

export default UserReport;
